import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import styled from "styled-components"

const Container = styled(Box).attrs((props) => ({
  contain: props.contain,
  mb: 5,
  px: 2,
}))``

const OrderRouteWrapper = ({ children, contain, title }) => (
  <Container contain={contain}>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
  </Container>
)

OrderRouteWrapper.propTypes = {
  children: PropTypes.node,
  contain: PropTypes.bool,
  title: PropTypes.string,
}

export default OrderRouteWrapper
